import React from "react";
import { connect } from "react-redux";

import ViewToggle from "../../common/files/filters/ViewToggle";
import Card from "../../common/Card";
import FileTable from "../../common/files/FileTable";
import FileGrid from "../../common/files/FileGrid";
import Button from "../../common/form/Button";
import * as fromData from "../../../store/data/reducer";
import * as fromFiles from "../../../store/files/reducer";
import { setView, setFileViewed } from "../../../store/files/actions";
import "./home.css";

const Home = ({
    files,
    firstPanel,
    secondPanel,
    view,
    activeToggle,
    setView,
    setFileViewed,
}) => {
    const renderPanelMessages = () => {
        return (
            <div className="home__header">
                <Card className="home__header-card">
                    <h2
                        dangerouslySetInnerHTML={{ __html: firstPanel.title }}
                    ></h2>
                    <p>{firstPanel.message}</p>
                </Card>
                <Card className="home__header-card">
                    <h2
                        dangerouslySetInnerHTML={{ __html: secondPanel.title }}
                    ></h2>
                    <p>{secondPanel.message}</p>
                </Card>
            </div>
        );
    };

    return (
        <div className="home">
            {firstPanel && secondPanel && renderPanelMessages()}
            <div className="home__body">
                <div className="home__title-wrap">
                    <h2 className="home__title">
                        Your Recent Files
                    </h2>
                    <ViewToggle
                        toggleView={setView}
                        className="home__view-toggle"
                        activeToggle={activeToggle}
                    />
                    <Button to="/my-files" color="primary">
                        View All Files
                    </Button>
                </div>
                {view === "list" && (
                    <FileTable
                        files={files}
                        sortOrder={false}
                        handleFileClick={setFileViewed}
                    />
                )}
                {view === "grid" && (
                    <FileGrid files={files} handleFileClick={setFileViewed} />
                )}
            </div>
            <div className="home__footer">
                <Button to="/my-files" color="primary">
                    View All Files
                </Button>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        files: fromFiles.getRecentFiles(state.files),
        firstPanel: fromData.getMessageById(state.data, "home_1"),
        secondPanel: fromData.getMessageById(state.data, "home_2"),
        view: fromFiles.getView(state.files),
        activeToggle: fromFiles.getActiveToggle(state.files),
    };
};

export default connect(mapStateToProps, { setView, setFileViewed })(Home);



// WEBPACK FOOTER //
// ./src/components/routes/Home/index.js